import React, { useId, useState } from 'react';
import classnames from 'classnames';
import { RichText } from 'src/components/RichText/RichText';

import classes from './ProductFaq.scss';

export type ProductFaqItem = {
    question: string;
    answer: string;
};

type Props = {
    faq: ProductFaqItem[];
};

export const ProductFaq: React.FC<Props> = ({ faq }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(faq.length > 0 ? 0 : null);
    const idPrefix = useId();

    if (faq.length === 0) {
        return null;
    }

    const handleToggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className={classes.root} aria-labelledby="product-faq-title">
            <h2 id="product-faq-title" className={classes.title}>
                Frequently Asked Questions
            </h2>
            <div className={classes.accordion}>
                {faq.map((item, index) => {
                    const isOpen = openIndex === index;
                    const buttonId = `${idPrefix}-button-${index}`;
                    const panelId = `${idPrefix}-panel-${index}`;

                    return (
                        <div
                            key={`${item.question}-${index}`}
                            className={classnames(classes.item, {
                                [classes.itemOpen]: isOpen,
                            })}
                        >
                            <button
                                id={buttonId}
                                className={classes.button}
                                onClick={() => handleToggle(index)}
                                aria-expanded={isOpen}
                                aria-controls={panelId}
                                type="button"
                            >
                                <span className={classes.question}>{item.question}</span>
                                <span className={classes.icon} aria-hidden="true">
                                    {isOpen ? '-' : '+'}
                                </span>
                            </button>
                            <div
                                id={panelId}
                                role="region"
                                aria-labelledby={buttonId}
                                inert={!isOpen}
                                className={classnames(classes.panel, {
                                    [classes.panelOpen]: isOpen,
                                })}
                            >
                                <div className={classes.panelContent}>
                                    <RichText content={item.answer} />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default ProductFaq;
